export const MOBILE_BREAKPOINT = 600;
export const playerControlSeekBarWrapperId = "player-controls-seek-bar-wrapper";
